import React from "react";
import { CheckCircle2 } from "lucide-react";

// Import local images
import missionImg1 from "./Images/m1.jpg";
import missionImg2 from "./Images/v1.jpg";

const MissionSection = () => {
  return (
    <section className="bg-white py-16 px-6 md:px-16">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
        
        {/* Left Side Images */}
        <div className="grid gap-6">
          <div className="overflow-hidden rounded-2xl shadow-md">
            <img
              src={missionImg1}
              alt="Bulk products"
              className="w-full h-64 object-cover transform hover:scale-105 transition duration-500"
            />
          </div>
          <div className="overflow-hidden rounded-2xl shadow-md">
            <img
              src={missionImg2}
              alt="Delivery van"
              className="w-full h-64 object-cover transform hover:scale-105 transition duration-500"
            />
          </div>
        </div>

        {/* Right Side Content */}
        <div className="bg-gradient-to-r from-[#f4faf5] to-white p-8 rounded-2xl shadow-sm">
          <h2 className="text-3xl md:text-4xl font-extrabold text-green-900 mb-6">
            Our Mission
          </h2>
          <p className="text-gray-700 leading-relaxed mb-8">
            At <strong>DailyGo</strong>, our mission is to redefine wholesale by
            making procurement simple, affordable, and accessible for every type
            of business. We connect retailers, resellers, and enterprises with
            genuine suppliers, delivering unbeatable daily deals and a seamless
            digital shopping experience.
            <br /> <br />
            We are committed to empowering businesses of all sizes—whether
            they’re placing small orders or large-scale bulk requirements—with
            fair pricing, quick deliveries, and trustworthy partnerships. By
            focusing on reliability, efficiency, and customer success, we’re
            shaping a stronger and more connected wholesale ecosystem.
          </p>

          {/* Bullet Points */}
          <ul className="space-y-5">
            {[
              "Making Procurement Easy and Affordable",
              "Bridging Businesses with Trusted Suppliers",
              "Delivering Consistent Value Every Day",
              "Driving Growth Through Smart Savings",
            ].map((item, idx) => (
              <li
                key={idx}
                className="flex items-start gap-3 group hover:translate-x-2 transition-transform duration-300"
              >
                <CheckCircle2 className="text-green-600 w-6 h-6 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span className="font-semibold text-gray-900">{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
};

export default MissionSection;
